import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import App from './App.vue';
import './assets/print.css';

// Pages
import PageHome from './components/PageHome.vue';
import PageParticipants from './components/PageParticipants.vue';
import PageSchedules from './components/PageSchedules.vue';
import PageGateOrders from './components/PageGateOrders.vue';

// Components
import GateCalender from './components/GateCalender.vue';
import GateOrder from './components/GateOrder.vue';
import GateWeeks from './components/GateWeeks.vue';
import ParticipantsAll from './components/ParticipantsAll.vue';
import ParticipantSingle from './components/ParticipantSingle.vue';
import ScheduleSingle from './components/ScheduleSingle.vue';
import PrintGate from './components/PrintGate.vue';

const app = createApp(App);
const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', component: PageHome },
    { path: '/participants', component: PageParticipants },
    { path: '/participants/:participantID', component: ParticipantSingle },
    { path: '/schedules', component: PageSchedules },
    { path: '/schedules/:weekID', component: ScheduleSingle },
    { path: '/gate-orders', component: PageGateOrders },
    { path: '/print/:gateID', component: PrintGate}
  ]
});

app.component('gate-calendar', GateCalender);
app.component('gate-order', GateOrder);
app.component('gate-weeks', GateWeeks);
app.component('participants-all', ParticipantsAll);
app.component('participant-single', ParticipantSingle);
app.component('schedule-single', ScheduleSingle);
app.component('print-gate', PrintGate);

app.use(router);

app.mount('#app')